/* eslint-disable i18n-scan/no-inline-content */
import { DeleteIcon, Link } from '@paypalcorp/pp-react'
import React from 'react'

export const BorderedTable = ({ headerData, bodyData = [] }) => {
  return (
    <table className="dev_dash__bordered-table">
      <thead>
        <tr className="dev_dash__bordered-table__thead_trow">
          {headerData.map((header, index) => (
            <React.Fragment key={index}>
              <th>{header.title}</th>
            </React.Fragment>
          ))}
        </tr>
      </thead>
      <tbody>
        {bodyData.length === 0 ? (
          <tr className="dev_dash__bordered-table__tbody_trow">
            <td style={{ padding: '0.3125rem 0' }}>
              Create your first credential to view it here.
            </td>
          </tr>
        ) : (
          bodyData &&
          bodyData.map((body, _index) => (
            <tr className="dev_dash__bordered-table__tbody_trow" key={_index}>
              <td style={{ padding: '0.3125rem 0' }}>
                <Link href={body.path}>{body.title}</Link>
              </td>
              {body.hasDeleteButton ? (
                <td>
                  <span style={{ cursor: 'pointer' }}>
                    <DeleteIcon size="sm" style={{ verticalAlign: 'middle' }} />
                  </span>
                </td>
              ) : (
                <td>System generated, no actions available.</td>
              )}
            </tr>
          ))
        )}
      </tbody>
    </table>
  )
}
